
import React from "react";
import { ChartContainer } from "@/components/ui/chart";
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

interface PredictionsChartProps {
  data: {
    name: string;
    "Palpites Milhar": number;
    "Palpites Centena": number;
    "Palpites Grupo": number;
  }[];
}

const PredictionsChart: React.FC<PredictionsChartProps> = ({ data }) => {
  return (
    <ChartContainer config={{
      milhar: { label: "Palpites Milhar", color: "rgba(59, 130, 246, 0.7)" },
      centena: { label: "Palpites Centena", color: "rgba(139, 92, 246, 0.7)" },
      grupo: { label: "Palpites Grupo", color: "rgba(16, 185, 129, 0.7)" },
    }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Palpites Milhar" fill="rgba(59, 130, 246, 0.7)" />
          <Bar dataKey="Palpites Centena" fill="rgba(139, 92, 246, 0.7)" />
          <Bar dataKey="Palpites Grupo" fill="rgba(16, 185, 129, 0.7)" />
        </BarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};

export default PredictionsChart;
